module.exports = "{{from}}: <span class=\"lpview_fromInput input\"></span> {{to}}: <span class=\"lpview_toInput input\"></span>";